import {
  doc,
  getDoc,
  serverTimestamp,
  setDoc
} from "firebase/firestore";

import { auth, db } from "../firebase";

const COLLECTION_NAME = "exemptionAssignmentTemplates";

export const EXEMPTION_UNASSIGNED_VALUE = "";
export const EXEMPTION_EXCLUDED_VALUE = "__EXCLUDED__";

export const getAssignmentTemplate = async (companyKey) => {
  const cleanCompanyKey = String(companyKey || "").trim();

  if (!cleanCompanyKey) return null;

  const snapshot = await getDoc(doc(db, COLLECTION_NAME, cleanCompanyKey));

  if (!snapshot.exists()) return null;

  return {
    id: snapshot.id,
    ...snapshot.data()
  };
};

export const saveAssignmentTemplate = async ({
  companyKey,
  companyName,
  assignments
}) => {
  const cleanCompanyKey = String(companyKey || "").trim();

  if (!cleanCompanyKey) {
    throw new Error("Firma seçimi zorunludur.");
  }

  await setDoc(doc(db, COLLECTION_NAME, cleanCompanyKey), {
    companyKey: cleanCompanyKey,
    companyName: companyName || cleanCompanyKey,
    assignments: assignments || {},
    updatedAt: serverTimestamp(),
    updatedBy: auth.currentUser?.email || ""
  }, { merge: true });
};
